import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["data-title", "data-componentState", "data-width", "data-height"];
const _hoisted_2 = ["id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        "data-type": "component",
        "data-title": _ctx.name,
        "data-componentState": _ctx.processedState,
        "data-width": _ctx.width,
        "data-height": _ctx.height
    }, [
        _createElementVNode("div", {
            id: _ctx.slugID,
            style: _normalizeStyle(_ctx.style + '; height:100%;'),
            class: _normalizeClass('tab-pane fade show active container-fluid p-' +
                _ctx.paddingSize.toString() +
                ' ' +
                _ctx.extraClass)
        }, [
            _renderSlot(_ctx.$slots, "default")
        ], 14, _hoisted_2)
    ], 8, _hoisted_1));
}
